import { render } from "./CambioClaveUsuarioForm.vue?vue&type=template&id=73cdc7d3&scoped=true"
import script from "./CambioClaveUsuarioForm.vue?vue&type=script&lang=js"
export * from "./CambioClaveUsuarioForm.vue?vue&type=script&lang=js"

import "./CambioClaveUsuarioForm.vue?vue&type=style&index=0&id=73cdc7d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73cdc7d3"]])

export default __exports__